<template>
  <div class="layout-footer">
    <div class="base-warpper">
      <ul class="url-links">
        <li><a href="https://itf.sjtu.edu.cn/" target="_blank" title="学院首页">学院首页</a></li>
        <!-- <li><a href="https://itf.sjtu.edu.cn/index/sitemap" target="_blank" title="帮助中心">帮助中心</a></li> -->
        <li><a href="https://itf.sjtu.edu.cn/page-contactus.html" target="_blank" title="联系我们">联系我们</a></li>
      </ul>
      <div class="info">
        <span class="copy"> {{ appConfig.icp_beian }} Copyright 2022 © {{ appConfig.organization }} 版权所有 </span>
        <span> 技术支持：<a href="https://www.mbachina.com" target="_blank" title="MBAChina网—MBA管理精英成长平台">MBAChina</a> </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['appConfig'])
  }
}
</script>

<style lang="scss" scoped>
.layout-footer {
  // margin-top: 70px;
  background-color: #eaeaea;
  padding: 22px 0;
  .url-links {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid #d1d1d1;
    padding-bottom: 20px;
    li {
      list-style: none;
      a {
        font-size: 14px;
        color: #7d7d7d;
      }
      &:not(:last-child) {
        &::after {
          content: '|';
          color: #7d7d7d;
          margin: 0 10px;
        }
      }
    }
  }
  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    font-size: 14px;
    color: #7d7d7d;
    a {
      color: #7d7d7d;
    }
  }
}
</style>
